/* WonderBuddy Content Library - shared behaviour for every wb-cl-* section.
   Safe to load once per section: everything below is idempotent. */
(function () {
  if (window.wbClInit) { return; }
  window.wbClInit = true;

  /* Tell the stylesheet the script is alive. Until this class exists the
     .reveal elements stay fully visible and every tab panel stays on show, so
     a blocked script can never blank the page or hide four fifths of its
     content. */
  document.documentElement.classList.add('wb-cl-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---------------------------------------------------- */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }

  function reveal(scope) {
    var nodes = (scope || document).querySelectorAll('.wb-cl .reveal:not(.visible)');
    Array.prototype.forEach.call(nodes, function (el) {
      if (io) { io.observe(el); } else { el.classList.add('visible'); }
    });
  }

  /* ---- tabs -------------------------------------------------------------
     One controller for both tabbed sections. A key may own SEVERAL panels
     rather than one: the Divine section keeps its photo in the left column
     and its words in the right, and both have to change together when a tab
     is pressed. Matching on [data-cl-panel="key"] instead of a single id is
     what lets the same code drive a one-panel layout and a split one.

     Every panel is rendered by Liquid and simply hidden here, so the words
     are in the HTML for search engines and for anyone whose JS never
     arrives. */
  function tabs(scope) {
    var roots = (scope || document).querySelectorAll('.wb-cl [data-cl-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.wbTabs) { return; }
      root.dataset.wbTabs = '1';

      var buttons = root.querySelectorAll('[data-cl-tab]');
      if (!buttons.length) { return; }

      function show(key) {
        Array.prototype.forEach.call(buttons, function (b) {
          b.setAttribute('aria-selected', b.dataset.clTab === key ? 'true' : 'false');
          b.tabIndex = b.dataset.clTab === key ? 0 : -1;
        });
        var panels = root.querySelectorAll('[data-cl-panel]');
        Array.prototype.forEach.call(panels, function (p) {
          if (p.dataset.clPanel === key) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      }

      Array.prototype.forEach.call(buttons, function (b) {
        b.addEventListener('click', function () { show(b.dataset.clTab); });
        /* Left/right arrows move between tabs, which is what a screen reader
           user expects of anything marked up as a tablist. */
        b.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
          if (!dir) { return; }
          e.preventDefault();
          var list = Array.prototype.slice.call(buttons);
          var at = list.indexOf(b);
          var to = list[(at + dir + list.length) % list.length];
          show(to.dataset.clTab);
          to.focus();
        });
      });

      show(buttons[0].dataset.clTab);
    });
  }

  /* ---- carousels --------------------------------------------------------
     CSS decides whether a row is a grid or a shelf, and whether the nav is
     visible, entirely through the section's own tokens. This code only builds
     the arrows and dots from the real card count, so the controls can never
     disagree with the layout. */
  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cl-carousel-arrow';
    b.setAttribute('aria-label', dir < 0 ? 'Previous' : 'Next');
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">' +
      (dir < 0 ? '<path d="m15 5-7 7 7 7"/>' : '<path d="m9 5 7 7-7 7"/>') + '</svg>';
    return b;
  }

  function carousel(root) {
    if (root.dataset.wbBound) { return; }
    root.dataset.wbBound = '1';

    var viewport = root.querySelector('.cl-carousel-viewport');
    var track = viewport && viewport.firstElementChild;
    if (!track) { return; }

    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) { return; }

    var nav = document.createElement('div');
    nav.className = 'cl-carousel-nav';
    var prev = arrow(-1);
    var next = arrow(1);
    var dots = document.createElement('div');
    dots.className = 'cl-carousel-dots';

    cards.forEach(function (card, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'cl-carousel-dot';
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.addEventListener('click', function () { goTo(i); });
      dots.appendChild(d);
    });

    nav.appendChild(prev); nav.appendChild(dots); nav.appendChild(next);
    root.appendChild(nav);

    /* A card counts as "current" when its start edge sits at the viewport's
       start edge - that is what scroll-snap-align: start actually snaps to,
       so this has to match it rather than guessing from the row's centre. */
    function currentDom() {
      var vLeft = viewport.getBoundingClientRect().left;
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.getBoundingClientRect().left - vLeft);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function cardLeft(c) {
      return viewport.scrollLeft + (c.getBoundingClientRect().left - viewport.getBoundingClientRect().left);
    }

    var idx = 0;

    function paint() {
      Array.prototype.forEach.call(dots.children, function (d, n) {
        d.classList.toggle('is-active', n === idx);
      });
      /* Disabling by comparing idx to cards.length - 1 only works when one
         card fills the viewport. Once several show at once, the last card's
         left edge can never reach the viewport's left edge - there is not
         enough row left to scroll it that far - so currentDom() never reports
         the final index and "next" would stay live forever. Reading the real
         scroll position instead is correct however many cards are on screen.

         The row's own left padding is part of the resting position too:
         scroll-snap-align: start docks the first card, padding included,
         against the viewport edge, so "nothing left to scroll" reads as
         scrollLeft === that padding rather than 0. It is read off the track
         so it cannot drift out of sync with the editor setting. */
      var startPad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var max = viewport.scrollWidth - viewport.clientWidth;
      prev.disabled = viewport.scrollLeft <= startPad + 1;
      next.disabled = viewport.scrollLeft >= max - 1;
    }

    function goTo(n) {
      if (n < 0 || n >= cards.length) { return; }
      idx = n;
      var c = cards[n];
      viewport.scrollTo({ left: cardLeft(c), behavior: reduce ? 'instant' : 'smooth' });
      paint();
    }

    prev.addEventListener('click', function () { goTo(idx - 1); });
    next.addEventListener('click', function () { goTo(idx + 1); });

    var tick;
    viewport.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () { idx = currentDom(); paint(); }, 80);
    }, { passive: true });

    window.addEventListener('resize', function () {
      clearTimeout(tick);
      tick = setTimeout(function () { idx = currentDom(); paint(); }, 120);
    });

    idx = currentDom();
    paint();
  }

  function carousels(scope) {
    var roots = (scope || document).querySelectorAll('.wb-cl [data-cl-carousel]');
    Array.prototype.forEach.call(roots, carousel);
  }

  function start(scope) { reveal(scope); tabs(scope); carousels(scope); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  /* The theme editor re-renders one section at a time - rescan just that one. */
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
